module.exports = __webpack_public_path__ + "static/img/def_data_2.95ddf4d1.png";